"use strict";
/// <reference path="irep.js"/>
IREP.fivestarlanding = (function () {
    var errorPanel;
    var init = function (options) {
    	errorPanel = options.errorPanel;
    	
    	$('#btnHome').on('click', function () {
    		$(".celebrateContent").hide();
    		$(".motivateContent").hide();
    		$(".getRewardedContent").hide();
    		$(".homeContent").show();
    	});

    	$('#btnCelebrate').on('click', function () {
    		$(".homeContent").hide();
    		$(".motivateContent").hide();
    		$(".getRewardedContent").hide();
    		$(".celebrateContent").show();
    	});

    	$('#btnMotivate').on('click', function () {
    		$(".celebrateContent").hide();
    		$(".homeContent").hide();
    		$(".getRewardedContent").hide();
    		$(".motivateContent").show();
    	});

    	$('#btnReward').on('click', function () {
    		$(".celebrateContent").hide();
    		$(".motivateContent").hide();
    		$(".homeContent").hide();
    		$(".getRewardedContent").show();
    	});
    };

    var checkUP = function () {
        $(errorPanel + " > div").hide();

        if ($("#UserName").val() == "" || $("#Password").val() == "") {
            $("#UPRequired").show();
            $(errorPanel).show();
            return false;
        }

        return true;
    };

    return {
        init: init,
        checkUP: checkUP
    };

}());

